import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import AddAddress from "./AddAddress";
import Details from "./Details";
import useAddress from "./useAddress";
import ChooseAddress from './ChooseAddress';

const Address = () => {
  const {
    loading,
    formData,
    errorMsg,
    addressFormat,
    countryCodeDropdown,
    shipping_address,
    showAddAddress,
    is_other_addresses_available,
    chooseAddressPopup,
    changeChooseAddress,
    toggleAddAddress,
    handleChangeCountry,
    handleChangeFormData,
    pincodeChange,
    pincodeFocus,
    handleChangeCountryCode,
    toggleCountryCode,
    phoneNumberChange,
    phoneNumberFocus,
    onSubmitForm,
    handleSelectShippingAddress
  } = useAddress();

  return (
    <section>
      <Card
        className="
            w-full border-0 overflow-hidden 
            relative sans relative rounded-none 
            py-10 px-6
          "
      >
        <CardHeader className="space-y-0 px-0 py-0 flex flex-row justify-between items-center">
          <CardTitle>SHIPPING & BILLING</CardTitle>
          {
                    is_other_addresses_available &&
                    <Dialog open={chooseAddressPopup} onOpenChange={changeChooseAddress}>
                        <DialogTrigger
                            asChild
                            id=""
                        >
                            <Button
                                variant="secondary"
                                className="
                        bg-white hover:bg-white rounded-none 
                        px-2 py-0  h-[45px] border-0
                        items-center justify-between cursor-pointer 
                        underline
                    "
                            >
                                Change
                            </Button>
                        </DialogTrigger>
                        <ChooseAddress 
                          handleSelectShippingAddress={handleSelectShippingAddress}
                          toggleAddAddress={toggleAddAddress}
                        />
                    </Dialog>
                }
        </CardHeader>

        {
          shipping_address && !showAddAddress ?
            <Details
              shipping_address={shipping_address}
              selected={true}
              toggleAddAddress={toggleAddAddress}
              handleSelectShippingAddress={handleSelectShippingAddress}
            /> :
            <AddAddress
              formData={formData}
              addressFormat={addressFormat}
              errorMsg={errorMsg}
              countryCodeDropdown={countryCodeDropdown}
              loading={loading}
              handleChangeCountry={handleChangeCountry}
              pincodeChange={pincodeChange}
              pincodeFocus={pincodeFocus}
              handleChangeFormData={handleChangeFormData}
              handleChangeCountryCode={handleChangeCountryCode}
              toggleCountryCode={toggleCountryCode}
              phoneNumberChange={phoneNumberChange}
              phoneNumberFocus={phoneNumberFocus}
              onSubmitForm={onSubmitForm}
            />
        }
      </Card>
    </section>
  );
};

export default Address;
